/**
 * Turn whatever the API put in `detail` into a string the UI can show.
 *
 * Every page renders `err.response.data.detail` straight into a toast or a
 * paragraph. FastAPI's own validation error (422) puts a LIST of objects there
 * — `{type, loc, msg, input, ctx}` each — and React cannot render an object as
 * a child, so one badly-formed email took the signup page down. Normalised
 * once here, in the client, rather than in 22 call sites.
 */
export function errorDetailToMessage(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (!d || typeof d !== "object") return "";
        const loc = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body" && x !== "query") : [];
        const field = loc.length ? String(loc[loc.length - 1]) : "";
        const msg = d.msg || d.message || "";
        return field && msg ? `${field}: ${msg}` : msg;
      })
      .filter(Boolean);
    return parts.join(". ");
  }
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  return "";
}

/**
 * Axios response interceptor: rewrite a non-string `detail` on an error
 * response so `err.response.data.detail` is always safe to render. The raw
 * value is kept on `data.errors` for anything that wants the structure.
 */
export function normaliseErrorResponse(error) {
  const data = error && error.response && error.response.data;
  if (data && typeof data === "object" && "detail" in data && typeof data.detail !== "string") {
    const message = errorDetailToMessage(data.detail);
    data.errors = data.detail;
    data.detail = message || undefined;
  }
  return Promise.reject(error);
}
